import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { FaSortDown } from 'react-icons/fa';
import { FaCaretRight } from 'react-icons/fa';
import { settingsPanelStyles as styles } from './styles';
import ReactTooltip from 'react-tooltip';

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

const link = require('../icons/link.svg');
const broken_link = require('../icons/broken_link.svg');

class MarginEditor extends Component<IProps, any> {
    state = {
        isExpanded: false,
        isChecked: false,
    };

    UpadteAllMargin(m) {
        this.props.descriptor.style.marginTop = m;
        this.props.descriptor.style.marginLeft = m;
        this.props.descriptor.style.marginRight = m;
        this.props.descriptor.style.marginBottom = m;
    }

    EquateAllMargin() {
        this.setState({ isChecked: !this.state.isChecked });
    }

    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div className={classes.panel}>
                    <span className={classes.header}>Margin</span>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'no-wrap',
                        alignItems: 'center',
                        padding: '4px 0 5px',
                    }}>
                    <div className={classes.flex}>
                        <span className={classes.sub_header}>Top</span>
                        <input
                            type="number"
                            value={descriptor.style.marginTop as number}
                            // style={{ borderTopLeftRadius: '4px' }}
                            onChange={(e) => (this.state.isChecked ? this.UpadteAllMargin(+e.target.value) : (descriptor.style.marginTop = +e.target.value))}
                            className={classes.input}
                        />
                    </div>
                    <div className={classes.flex}>
                        <span className={classes.sub_header}>Bottom</span>
                        <input type="number" value={descriptor.style.marginBottom as string} onChange={(e) => (this.state.isChecked ? this.UpadteAllMargin(+e.target.value) : (descriptor.style.marginBottom = +e.target.value))} className={classes.input} />
                    </div>
                    <div className={classes.flex}>
                        <span className={classes.sub_header}>Left</span>
                        <input type="number" name="Left-Margin" value={descriptor.style.marginLeft as number} onChange={(e) => (this.state.isChecked ? this.UpadteAllMargin(+e.target.value) : (descriptor.style.marginLeft = +e.target.value))} className={classes.input + ' txtMarginLeft'} />
                    </div>
                    <div className={classes.flex}>
                        <span className={classes.sub_header}>Right</span>
                        <input type="number" value={descriptor.style.marginRight as number} onChange={(e) => (this.state.isChecked ? this.UpadteAllMargin(+e.target.value) : (descriptor.style.marginRight = +e.target.value))} className={classes.input} />
                    </div>
                    <div className={classes.flex}>
                        <span className={classes.sub_header}>All</span>

                        <button data-for="link" title="Link Values" onClick={() => this.EquateAllMargin()}>
                            {this.state.isChecked ? <img src={link} /> : <img src={broken_link} />}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(MarginEditor));
